/** A world offer's words, apart from the board so they test without Pixi. */

export type WorldOfferState = 'soon' | 'open' | 'taken' | 'ended';

const DAY = 86_400;

/** "Sunday 29 November": the last day an offer runs to, when it ends at midnight UK time. */
export function lastDay(endsAt: number): string {
  // The offer ends at 00:00 on the next day; its last day is the one before.
  const d = new Date((endsAt - 1) * 1000);
  return d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/London' });
}

/** "Opens on Monday 23 November". */
export function opensOn(startsAt: number): string {
  const d = new Date(startsAt * 1000);
  return `Opens on ${d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/London' })}`;
}

/** "Last day!", "2 days left", "6 days left": how long an open offer has. */
export function timeLeft(endsAt: number, now: number): string {
  const days = Math.ceil((endsAt - now) / DAY);
  if (days <= 1) return 'Last day!';
  // Counting down only means something for a short offer.
  return days <= 14 ? `${days} days left` : '';
}

/** The board's lines for a state. */
export function offerLines(
  state: WorldOfferState,
  name: string,
  games: number,
  startsAt: number,
  endsAt: number,
  now: number,
): { title: string; line: string; small: string; button: string } {
  switch (state) {
    case 'open':
      return {
        title: 'THIS WEEK ONLY',
        line: `Every game in ${name}, free.`,
        small: `Ends at midnight on ${lastDay(endsAt)}. ${timeLeft(endsAt, now)}`.trim(),
        button: 'OPEN THE WORLD',
      };
    case 'taken':
      return {
        title: `${name.toUpperCase()} IS YOURS`,
        line: `All ${games + 1} games in ${name} are open.`,
        small: 'Yours to keep.',
        button: 'GO THERE',
      };
    case 'soon':
      return { title: 'COMING SOON', line: `Every game in ${name}, free for a week.`, small: `${opensOn(startsAt)}.`, button: 'OK' };
    case 'ended':
    default:
      return {
        title: 'THIS OFFER HAS ENDED',
        line: `${name} was free until midnight on ${lastDay(endsAt)}.`,
        small: "Follow our Facebook Page so you don't miss the next one.",
        button: 'OK',
      };
  }
}
